import React from 'react';
import Bugsnag from '@bugsnag/js'

let ErrorBoundary;
// if (process.env.NEXT_PUBLIC_NODE_ENV === 'production' || process.env.NEXT_PUBLIC_NODE_ENV === 'staging') {
    // Bugsnag.start({
    //     apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY,
    //     appVersion: process.env.NEXT_PUBLIC_APP_VERSION,
    //     plugins: [new BugsnagPluginReact()],
    //     onError: (event) => {
    //         event.errors.forEach((error) => {
    //             error.stacktrace.forEach((frame) => {
    //                 if (frame.file) {
    //                     frame.file = frame.file.replace(/\/(auth|administration|dashboard)\//g, (match) => {
    //                         return match.replace(/(auth|administration|dashboard)/, '($&)');
    //                     })
    //                 }
    //             });
    //         });
    //     },
    // })

//     ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)
// } else {
//     ErrorBoundary = ({children}) => <>{children}</>;
// }

export default ErrorBoundary

